module.exports = __webpack_public_path__ + "static/media/bg.914b883c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/bg.png
// module id = 1615
// module chunks = 0